export default function Unauthorized() {
  return (
    <div className="header-container flex-row-align">
      <div className="flex-row space-evenly align-items w-100 ptb-1">
        <div>
          <h1 className="text-lg font-semibold">401 - Unauthorized</h1>
          <p>You do not have permission to access this page.</p>
        </div>
        <div className="logout flex-row-align">
          <a className="btn btn-second-color" href="/">
            Go back
          </a>
        </div>
      </div>
    </div>
  );
}
